import React from "react";
import { Box } from "@mui/material";


export default function ProgressBar({ value }) {
    return (
        <Box
            sx={{
                mt: 1,
                width: "100%",
                height: 8,
                bgcolor: "#EEF2F7",
                borderRadius: 10,
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    width: `${value}%`,
                    height: "100%",
                    bgcolor: "#51A2FF",
                    borderRadius: 10,
                    transition: ".3s",
                }}
            />
        </Box>
    );
}
